/* eslint-disable no-unused-expressions */
import React from 'react';
import Layout from './src/components/layout';

export const onClientEntry = () => {
  // Modern browsers only - React 18 doesn't support IE11
  import('web-vitals');
};

export function onServiceWorkerUpdateReady() {
  // should force a refresh of site to remove any cached files.
  window.location.reload();
}

export const wrapPageElement = ({ element }) => <Layout>{element}</Layout>;

require('@carvana/showroom-css-theme/Theme.css');
require('@carvana/showroom-forms/index.css');
